import React, { createContext, useState, useEffect } from "react";

export const WishlistContext = createContext(null);

const WishlistProvider = ({ children }) => {
  const [wishlist, setWishlist] = useState(() => {
    try {
      const stored = localStorage.getItem("aavryaa-wishlist");
      return stored ? JSON.parse(stored) : [];
    } catch { return []; }
  });

  const [wishlistOpen, setWishlistOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("aavryaa-wishlist", JSON.stringify(wishlist));
  }, [wishlist]);

  const toggleWishlist = (product) => {
    setWishlist(prev => {
      const exists = prev.find(p => p.id === product.id);
      return exists ? prev.filter(p => p.id !== product.id) : [...prev, product];
    });
  };

  const isWishlisted = (id) => wishlist.some(p => p.id === id);

  const removeFromWishlist = (id) => setWishlist(prev => prev.filter(p => p.id !== id));

  return (
    <WishlistContext.Provider value={{
      wishlist, toggleWishlist, isWishlisted, removeFromWishlist,
      wishlistOpen, setWishlistOpen,
    }}>
      {children}
    </WishlistContext.Provider>
  );
};

export default WishlistProvider;
